/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class QueryResultOverrideAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class QueryResultOverrideAPI {

		/**
		* @public
		* @function QueryResultOverrideAPI#setQueryResults
		* @description Sets the queryResults for the data task render step
		* @param {QueryResultsAPI} QueryResults The queryResults to be used in the data task
		*/
		setQueryResults() {}
	}

	return QueryResultOverrideAPI;
});
